<template>
  <v-card>
    <v-card-title class="headline">Wgrywanie szablon</v-card-title>
    <v-card-text>
      <v-container fluid>
        <v-row no-gutters>
          <v-col cols="5">
            <v-file-input v-model="file" label="Szablon" placeholder="Wybierz plik..." prepend-icon="fa-paperclip"></v-file-input>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-btn @click="save()" color="success">Dodaj szablon</v-btn>
      <v-spacer></v-spacer>
      <v-btn @click="close()" color="error">Zamknij</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import swal from "sweetalert";
import {settingsService} from "@/services";

export default {
  name: "UploadAgreeTemplate",
  props: ["typ"],
  data() {
    return {
      file: null
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    save()
    {
      if(this.file)
      {
        let formData = new FormData()
        formData.append('file',this.file);
        formData.append('type',this.typ)
        settingsService.uploadAgreeTemplate(formData).then((response) => {
          this.$emit('uploaded',response.data.result)
        }).catch(error=> {
          let err =error.response
          if(err.data != null && err.data.error && err.data.error.message)
          {
            this.showError(err.data.error.message)
          }
          else
          {
            this.showError("Nie można wgrać pliku")
          }

        })
      }
      else
      {
        this.showError('Nie wybrano pliku')
      }
    },
    showError(text) {
      swal({
        title: "Błąd",
        text: text,
        icon: "warning",
        button: "OK"
      }).then(() => {
      });
    }
  }

}
</script>

<style scoped>

</style>